import { Layout } from 'antd';
import React, { Fragment, useState } from 'react';

import AppHeader from './AppHeader';
import Mask from './Mask';
import NavSider from './NavSider';

import useDevices from '@hooks/useDevices';
import styles from './MainLayout.module.scss';
import AppBody from './mobile/AppBody';

const { Content, Footer } = Layout;

// nguồn: LayoutConfigs.NAV_WIDTH_EXPANDED = 280
const SIDEBAR_WIDTH_EXPAND = 280;

const MainLayout = ({ children }) => {
    const { isMobile } = useDevices();

    const [collapsed, setCollapsed] = useState(false);
    const toggleCollapsed = () => setCollapsed((prev) => !prev);

    return (
        <Fragment>
            {/* <Mask /> */}
            {(isMobile) ? (
                <div className={styles.masterLayout}>
                    <AppBody width="100%" className={styles.mainMobile}>
                        {children}
                    </AppBody>
                </div>
            ) : (
                <Layout hasSider>
                    <NavSider collapsed={collapsed} onCollapse={toggleCollapsed} width={SIDEBAR_WIDTH_EXPAND} />
                    <Layout>
                        <AppHeader collapsed={collapsed} onCollapse={toggleCollapsed} />
                        <Content className={styles.appContent}>
                        <div className={styles.wrapper}>{children}</div>
                        <Footer className={styles.appFooter}>
                            Copyright © IService, All Rights Reserved.
                        </Footer>
                        </Content>
                    </Layout>
                </Layout>
            )}
        </Fragment>
    );
};

export default MainLayout;
